import { UrlQueryParamsInterface } from 'pf-frontend-common/src/helper/url/query-params.interface';

import { objectFilterFalsy } from 'common/helper/object/filter/falsy';
import { PropertyParamStoreStateInterface } from 'common/module/property/param-store/state.interface';

export class PropertyQueryParamsAdapter {
  /**
   * Transforms to compact UrlQueryParamsInterface
   */
  public toCompact(params: UrlQueryParamsInterface): UrlQueryParamsInterface {
    return objectFilterFalsy(params);
  }

  /**
   * Transforms PropertyParamStoreStateInterface into UrlQueryParamsInterface
   */
  public fromPropertyParamStoreParams(params: PropertyParamStoreStateInterface): UrlQueryParamsInterface {
    return {
      page: params.pageNumber,
      order_by: params.sort,
      category_id: params.filterCategoryId,
    };
  }

  /**
   * Transforms UrlQueryParamsInterface into PropertyParamStoreStateInterface
   */
  public toPropertyParamStoreParams(params: UrlQueryParamsInterface): PropertyParamStoreStateInterface {
    return {
      pageNumber: parseInt(params.page, 10) || 1,
      sort: params.orderBy || '',
      filterCategoryId: params.categoryId || '',
    };
  }
}
